import { createReducer, on } from '@ngrx/store';
import { AccessControlListApiActions } from './location-acl.actions';
import { adapter, initialState } from './location-acl.state';

export const locationAclReducer = createReducer(
  initialState,
  on(AccessControlListApiActions.locationAclLoaded, (state, { locationAcl }) => adapter.addOne(locationAcl, state)),
  on(AccessControlListApiActions.locationAclMemberPut, (state, { aclMember }) =>
    adapter.updateOne(
      {
        id: aclMember.resourceId || '', // empty means all locations
        changes: {
          users:
            (state.entities[aclMember.resourceId || '']?.users ?? []).find((x) => x.member === aclMember.member) ===
            undefined
              ? (state.entities[aclMember.resourceId || '']?.users ?? []).concat([aclMember]) // Add the member when it doesn't exist on the resource yet
              : (state.entities[aclMember.resourceId || '']?.users ?? []).map(
                  (x) => (x.member === aclMember.member ? aclMember : x) // Update the member when it already exists on the resource
                ),
        },
      },
      state
    )
  ),
  on(AccessControlListApiActions.locationAclGroupPut, (state, { aclGroup }) =>
    adapter.updateOne(
      {
        id: aclGroup.resourceId || '',
        changes: {
          groups:
            (state.entities[aclGroup.resourceId || '']?.groups ?? []).find((x) => x.groupId === aclGroup.groupId) ===
            undefined
              ? (state.entities[aclGroup.resourceId || '']?.groups ?? []).concat([aclGroup]) // Add the group when it doesn't exist on the resource yet
              : (state.entities[aclGroup.resourceId || '']?.groups ?? []).map(
                  (x) => (x.groupId === aclGroup.groupId ? aclGroup : x) // Update the group when it already exists on the resource
                ),
        },
      },
      state
    )
  ),
  on(AccessControlListApiActions.locationAclGroupRemove, (state, { aclGroup }) =>
    adapter.updateOne(
      {
        id: aclGroup.resourceId || '',
        changes: {
          groups: (state.entities[aclGroup.resourceId || '']?.groups ?? []).filter(
            (x) => x.groupId !== aclGroup.groupId
          ),
        },
      },
      state
    )
  )
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectLocationAclIds = selectIds;
export const selectLocationAcls = selectEntities;
export const selectAllLocationAcls = selectAll;
